import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FiRefreshCw } from "react-icons/fi";
import { useExport } from "../../hooks/useExport";
import { useMarketIndicators } from "../../context/MarketIndicatorContext";
import {
  useGlobalLiveFeed,
  liveCrossoverStatus,
} from "../../hooks/useGlobalLiveFeed";
import "./OpenHighLowScreener.css";

// const MarketScreener = ({
//   screenerType = "day_gainers",
//   title = "Top Gainers",
//   subtitle = "Stocks with the highest gains in today's market",
// }) => {
//   const navigate = useNavigate();

//   const [sortKey, setSortKey] = useState("pctChange");
//   const [sortDir, setSortDir] = useState("desc");

//   const { exportCSV, exportExcel, exporting } = useExport();

//   const { screener, getScreenerData, screenerLoading } = useMarketIndicators();

//   // =====================================================
//   // FETCH DATA
//   // =====================================================

//   useEffect(() => {
//     if (!screenerType) return;

//     getScreenerData();
//   }, [screenerType]);
//   console.log("Screener Data", screener);

//   // =====================================================
//   // DATA
//   // =====================================================

//   //   const allStocks = useMemo(() => {
//   //     const rows = screener?.[screenerType] || [];

//   //     if (!Array.isArray(rows)) return [];

//   //     return rows
//   //       .map((item) => {
//   //         const open = Number(item?.open || 0);
//   //         const ltp = Number(item?.ltp || 0);

//   //         const riseFromOpen =
//   //           open && ltp ? Number((((ltp - open) / open) * 100).toFixed(2)) : 0;

//   //         return {
//   //           symbol: item?.symbol,

//   //           ltp: Number(item?.ltp || 0),

//   //           dayPriceChange: Number(item?.dayPriceChange || 0),

//   //           pctChange: Number(item?.pctChange || 0),

//   //           open: Number(item?.open || 0),

//   //           low: Number(item?.low || 0),

//   //           high: Number(item?.high || 0),

//   //           riseFromOpen:
//   //             item?.riseFromOpen != null
//   //               ? Number(item.riseFromOpen)
//   //               : riseFromOpen,

//   //           volume: Number(item?.volume || 0),
//   //         };
//   //       })
//   //       .filter((stock) => stock.symbol);
//   //   }, [screener, screenerType]);
//   const allStocks = useMemo(() => {
//     const rows = screener?.[screenerType] || [];
//     if (screener) if (!Array.isArray(rows)) return [];

//     return rows
//       .map((item) => {
//         const open = Number(item?.regularMarketOpen || 0);
//         const ltp = Number(item?.regularMarketPrice || 0);

//         const riseFromOpen =
//           open && ltp ? Number((((ltp - open) / open) * 100).toFixed(2)) : 0;

//         return {
//           symbol: item?.symbol,

//           ltp: Number(item?.regularMarketPrice || 0),

//           dayPriceChange: Number(item?.regularMarketChange || 0),

//           pctChange: Number(item?.regularMarketChangePercent || 0),

//           open: Number(item?.regularMarketOpen || 0),

//           low: Number(item?.regularMarketDayLow || 0),

//           high: Number(item?.regularMarketDayHigh || 0),

//           riseFromOpen,

//           volume: Number(item?.regularMarketVolume || 0),

//           // bonus fields you might want later
//           name: item?.shortName || item?.longName || item?.displayName,
//           currency: item?.currency || "USD",
//           marketCap: Number(item?.marketCap || 0),
//           fiftyTwoWeekHigh: Number(item?.fiftyTwoWeekHigh || 0),
//           fiftyTwoWeekLow: Number(item?.fiftyTwoWeekLow || 0),
//         };
//       })
//       .filter((stock) => stock.symbol && stock.ltp > 0);
//   }, [screener, screenerType]);

//   // =====================================================
//   // SORTING
//   // =====================================================

//   const sorted = useMemo(() => {
//     return [...allStocks].sort((a, b) => {
//       const aVal = a[sortKey] ?? 0;
//       const bVal = b[sortKey] ?? 0;

//       if (typeof aVal === "string") {
//         return sortDir === "asc"
//           ? aVal.localeCompare(bVal)
//           : bVal.localeCompare(aVal);
//       }

//       return sortDir === "asc" ? aVal - bVal : bVal - aVal;
//     });
//   }, [allStocks, sortKey, sortDir]);

//   const handleSort = (key) => {
//     if (sortKey === key) {
//       setSortDir((prev) => (prev === "desc" ? "asc" : "desc"));
//     } else {
//       setSortKey(key);
//       setSortDir("desc");
//     }
//   };

//   // =====================================================
//   // SORT TH
//   // =====================================================

//   const SortTh = ({ label, field, align }) => (
//     <th
//       onClick={() => handleSort(field)}
//       className={align === "left" ? "ohl__th-left" : ""}
//     >
//       {label}

//       {sortKey === field && (
//         <span className="ohl__sort-arrow">
//           {sortDir === "asc" ? " ↑" : " ↓"}
//         </span>
//       )}
//     </th>
//   );

//   // =====================================================
//   // REFRESH
//   // =====================================================

//   const handleRefresh = () => {
//     getScreenerData(screenerType);
//   };

//   // =====================================================
//   // EXPORT
//   // =====================================================

//   const EXPORT_COLUMNS = [
//     {
//       header: "Symbol",
//       key: "symbol",
//       width: 15,
//     },
//     {
//       header: "Price",
//       key: "ltp",
//       width: 12,
//     },
//     {
//       header: "Day Price Change",
//       key: "dayPriceChange",
//       width: 16,
//     },
//     {
//       header: "Change %",
//       key: "pctChange",
//       width: 12,
//     },
//     {
//       header: "Open",
//       key: "open",
//       width: 12,
//     },
//     {
//       header: "Low",
//       key: "low",
//       width: 12,
//     },
//     {
//       header: "High",
//       key: "high",
//       width: 12,
//     },
//     {
//       header: "Rise from Open %",
//       key: "riseFromOpen",
//       width: 16,
//     },
//     {
//       header: "Volume",
//       key: "volume",
//       width: 14,
//     },
//   ];

//   const buildExportRows = () =>
//     sorted.map((stock) => ({
//       symbol: stock.symbol,
//       ltp: stock.ltp ?? "",
//       dayPriceChange: stock.dayPriceChange ?? "",
//       pctChange: stock.pctChange ?? "",
//       open: stock.open ?? "",
//       low: stock.low ?? "",
//       high: stock.high ?? "",
//       riseFromOpen: stock.riseFromOpen ?? "",
//       volume: stock.volume ?? "",
//     }));

//   const handleDownloadCSV = () =>
//     exportCSV({
//       rows: buildExportRows(),
//       columns: EXPORT_COLUMNS,
//       filename: screenerType,
//       sheetName: title,
//     });

//   const handleDownloadExcel = () =>
//     exportExcel({
//       rows: buildExportRows(),
//       columns: EXPORT_COLUMNS,
//       filename: screenerType,
//       sheetName: title,
//     });

//   // =====================================================
//   // JSX
//   // =====================================================

//   return (
//     <div className="ohl">
//       {/* Header */}

//       <div className="ohl__header">
//         <div className="ohl__header-left">
//           <div className="ohl__title-row">
//             <button className="ohl__back" onClick={() => navigate(-1)}>
//               ←
//             </button>

//             <h1 className="ohl__title">{title}</h1>
//           </div>

//           <p className="ohl__sub">{subtitle}</p>

//           <div className="ohl__condition-pill">
//             <span>Market Screener</span>

//             <span className="ohl__condition-eq">=</span>

//             <span className="ohl__condition-val ohl__condition-val--bull">
//               {title}
//             </span>
//           </div>
//         </div>

//         <div className="ohl__header-right">
//           <button
//             className="ohl__refresh-btn"
//             onClick={handleRefresh}
//             disabled={screenerLoading}
//           >
//             <FiRefreshCw size={14} />
//           </button>

//           <button
//             className="ohl__refresh-btn"
//             onClick={handleDownloadCSV}
//             disabled={exporting || sorted.length === 0}
//           >
//             {exporting ? "…" : "CSV ⬇"}
//           </button>

//           <button
//             className="ohl__refresh-btn"
//             onClick={handleDownloadExcel}
//             disabled={exporting || sorted.length === 0}
//           >
//             {exporting ? "…" : "Excel ⬇"}
//           </button>
//         </div>
//       </div>

//       {/* Result count */}

//       <div className="ohl__result-bar">
//         <span className="ohl__result-count">
//           Showing <b>{sorted.length}</b> stocks
//         </span>

//         <span className="ohl__live-indicator">
//           <span className="ohl__live-dot" />
//           Screener
//         </span>
//       </div>

//       {/* Table */}

//       {screenerLoading && allStocks.length === 0 ? (
//         <div className="ohl__loading">Loading {title}...</div>
//       ) : sorted.length === 0 ? (
//         <div className="ohl__empty">
//           <div className="ohl__empty-icon">📈</div>

//           <div className="ohl__empty-title">No stocks found</div>

//           <div className="ohl__empty-sub">No results available for {title}</div>
//         </div>
//       ) : (
//         <div className="ohl__table-wrap">
//           <table className="ohl__table">
//             <thead>
//               <tr>
//                 <SortTh label="Name" field="symbol" align="left" />

//                 <SortTh label="Price" field="ltp" />

//                 <SortTh label="Day Price Change" field="dayPriceChange" />

//                 <SortTh label="Change %" field="pctChange" />

//                 <SortTh label="Open" field="open" />

//                 <SortTh label="Low" field="low" />

//                 <SortTh label="High" field="high" />

//                 <SortTh label="Rise from Open" field="riseFromOpen" />

//                 <SortTh label="Volume" field="volume" />
//               </tr>
//             </thead>

//             <tbody>
//               {sorted.map((stock) => (
//                 <tr
//                   key={stock.symbol}
//                   className="ohl__row"
//                   onClick={() => navigate(`/globaltest/${stock.symbol}`)}
//                 >
//                   {/* Symbol */}

//                   <td className="ohl__td-name">
//                     <span className="ohl__symbol">{stock.symbol}</span>
//                   </td>

//                   {/* Price */}

//                   <td className="ohl__td-num">
//                     {stock.ltp?.toLocaleString("en-US", {
//                       minimumFractionDigits: 2,
//                       maximumFractionDigits: 2,
//                     })}
//                   </td>

//                   {/* Price change */}

//                   <td
//                     className={`ohl__td-num ${
//                       stock.dayPriceChange > 0
//                         ? "ohl__green"
//                         : stock.dayPriceChange < 0
//                           ? "ohl__red"
//                           : ""
//                     }`}
//                   >
//                     {stock.dayPriceChange > 0 ? "+" : ""}

//                     {stock.dayPriceChange?.toFixed(2)}
//                   </td>

//                   {/* Percent change */}

//                   <td
//                     className={`ohl__td-num ${
//                       stock.pctChange > 0
//                         ? "ohl__green"
//                         : stock.pctChange < 0
//                           ? "ohl__red"
//                           : ""
//                     }`}
//                   >
//                     {stock.pctChange > 0 ? "+" : ""}
//                     {stock.pctChange?.toFixed(2)}%
//                   </td>

//                   {/* Open */}

//                   <td className="ohl__td-num">{stock.open?.toFixed(2)}</td>

//                   {/* Low */}

//                   <td className="ohl__td-num">{stock.low?.toFixed(2)}</td>

//                   {/* High */}

//                   <td className="ohl__td-num">{stock.high?.toFixed(2)}</td>

//                   {/* Rise From Open */}

//                   <td
//                     className={`ohl__td-num ${
//                       stock.riseFromOpen > 0
//                         ? "ohl__green"
//                         : stock.riseFromOpen < 0
//                           ? "ohl__red"
//                           : ""
//                     }`}
//                   >
//                     {stock.riseFromOpen > 0 ? "+" : ""}
//                     {stock.riseFromOpen?.toFixed(2)}%
//                   </td>

//                   {/* Volume */}

//                   <td className="ohl__td-num">
//                     {stock.volume?.toLocaleString("en-US")}
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>
//       )}

//       {/* Footer */}

//       {sorted.length > 0 && (
//         <div className="ohl__footer">
//           <span>Showing {sorted.length} results</span>
//         </div>
//       )}
//     </div>
//   );
// };

// export default MarketScreener;

// =====================================================
// SCREENERS SHOWN ON THIS PAGE
// Trending intentionally excluded for now
// =====================================================

// const SCREENER_TABS = [
//   {
//     key: "day_gainers",
//     label: "Top Gainers",
//     title: "Top Gainers",
//     subtitle: "Stocks with the highest gains in today's market",
//   },
//   {
//     key: "day_losers",
//     label: "Top Losers",
//     title: "Top Losers",
//     subtitle: "Stocks with the highest losses in today's market",
//   },
//   {
//     key: "most_actives",
//     label: "Most Active",
//     title: "Most Active Stocks",
//     subtitle: "Stocks with the highest intraday trading activity",
//   },
//   {
//     key: "undervalued_growth_stocks",
//     label: "Growth",
//     title: "Undervalued Growth Stocks",
//     subtitle: "Undervalued stocks showing earnings growth",
//   },
//   {
//     key: "growth_technology_stocks",
//     label: "Technology",
//     title: "Growth Technology Stocks",
//     subtitle: "Technology stocks showing strong revenue growth",
//   },
//   {
//     key: "undervalued_large_caps",
//     label: "Large Caps",
//     title: "Undervalued Large Caps",
//     subtitle: "Large-cap stocks trading at attractive valuations",
//   },
//   {
//     key: "aggressive_small_caps",
//     label: "Small Caps",
//     title: "Aggressive Small Caps",
//     subtitle: "Small-cap stocks showing earnings growth",
//   },
//   {
//     key: "small_cap_gainers",
//     label: "Small Cap Gainers",
//     title: "Small Cap Gainers",
//     subtitle: "Small-cap stocks with strong one-day price gains",
//   },
// ];

// const MarketScreener = () => {
//   const navigate = useNavigate();

//   // =====================================================
//   // STATE
//   // =====================================================

//   const [activeScreener, setActiveScreener] = useState("day_gainers");

//   const [sortKey, setSortKey] = useState("pctChange");
//   const [sortDir, setSortDir] = useState("desc");

//   const { exportCSV, exportExcel, exporting } = useExport();

//   const { screener, getScreenerData, screenerLoading } = useMarketIndicators();

//   // =====================================================
//   // CURRENT TAB CONFIG
//   // =====================================================

//   const activeConfig =
//     SCREENER_TABS.find((tab) => tab.key === activeScreener) || SCREENER_TABS[0];

//   const title = activeConfig.title;
//   const subtitle = activeConfig.subtitle;

//   // =====================================================
//   // FETCH ALL NON-TRENDING SCREENERS ONCE
//   // =====================================================

//   useEffect(() => {
//     const screenerKeys = SCREENER_TABS.map((tab) => tab.key);

//     getScreenerData();
//   }, []);
//   console.log("Screener data in market screener", screener);

//   // =====================================================
//   // CURRENT TAB RAW DATA
//   // =====================================================

//   const currentRows = screener?.[activeScreener] || [];

//   // =====================================================
//   // NORMALIZE DATA
//   // Same fields you are already using
//   // =====================================================

//   const allStocks = useMemo(() => {
//     const rows = screener?.[activeScreener] || [];

//     if (!Array.isArray(rows)) {
//       return [];
//     }

//     return rows
//       .map((item) => {
//         const open = Number(item?.regularMarketOpen || 0);

//         const ltp = Number(item?.regularMarketPrice || 0);

//         const riseFromOpen =
//           open && ltp ? Number((((ltp - open) / open) * 100).toFixed(2)) : 0;

//         return {
//           symbol: item?.symbol,

//           ltp: Number(item?.regularMarketPrice || 0),

//           dayPriceChange: Number(item?.regularMarketChange || 0),

//           pctChange: Number(item?.regularMarketChangePercent || 0),

//           open: Number(item?.regularMarketOpen || 0),

//           low: Number(item?.regularMarketDayLow || 0),

//           high: Number(item?.regularMarketDayHigh || 0),

//           riseFromOpen,

//           volume: Number(item?.regularMarketVolume || 0),

//           // Extra fields already available
//           name: item?.shortName || item?.longName || item?.displayName || "",

//           currency: item?.currency || "USD",

//           marketCap: Number(item?.marketCap || 0),

//           fiftyTwoWeekHigh: Number(item?.fiftyTwoWeekHigh || 0),

//           fiftyTwoWeekLow: Number(item?.fiftyTwoWeekLow || 0),
//         };
//       })
//       .filter((stock) => stock.symbol && stock.ltp > 0);
//   }, [screener, activeScreener]);

//   // =====================================================
//   // SORTING
//   // =====================================================

//   const sorted = useMemo(() => {
//     return [...allStocks].sort((a, b) => {
//       const aVal = a[sortKey] ?? 0;

//       const bVal = b[sortKey] ?? 0;

//       if (typeof aVal === "string") {
//         return sortDir === "asc"
//           ? aVal.localeCompare(bVal)
//           : bVal.localeCompare(aVal);
//       }

//       return sortDir === "asc" ? aVal - bVal : bVal - aVal;
//     });
//   }, [allStocks, sortKey, sortDir]);

//   // =====================================================
//   // SORT HANDLER
//   // =====================================================

//   const handleSort = (key) => {
//     if (sortKey === key) {
//       setSortDir((prev) => (prev === "desc" ? "asc" : "desc"));

//       return;
//     }

//     setSortKey(key);
//     setSortDir("desc");
//   };

//   // =====================================================
//   // SORTABLE TABLE HEADER
//   // =====================================================

//   const SortTh = ({ label, field, align }) => (
//     <th
//       onClick={() => handleSort(field)}
//       className={align === "left" ? "ohl__th-left" : ""}
//     >
//       {label}

//       {sortKey === field && (
//         <span className="ohl__sort-arrow">
//           {sortDir === "asc" ? " ↑" : " ↓"}
//         </span>
//       )}
//     </th>
//   );

//   // =====================================================
//   // TAB CHANGE
//   // =====================================================

//   const handleTabChange = (screenerKey) => {
//     setActiveScreener(screenerKey);

//     // Reset sorting when tab changes
//     setSortKey("pctChange");
//     setSortDir("desc");
//   };

//   // =====================================================
//   // REFRESH
//   // Fetch ONLY current tab
//   // =====================================================

//   const handleRefresh = () => {
//     getScreenerData(activeScreener);
//   };

//   // =====================================================
//   // EXPORT COLUMNS
//   // =====================================================

//   const EXPORT_COLUMNS = [
//     {
//       header: "Symbol",
//       key: "symbol",
//       width: 15,
//     },
//     {
//       header: "Price",
//       key: "ltp",
//       width: 12,
//     },
//     {
//       header: "Day Price Change",
//       key: "dayPriceChange",
//       width: 16,
//     },
//     {
//       header: "Change %",
//       key: "pctChange",
//       width: 12,
//     },
//     {
//       header: "Open",
//       key: "open",
//       width: 12,
//     },
//     {
//       header: "Low",
//       key: "low",
//       width: 12,
//     },
//     {
//       header: "High",
//       key: "high",
//       width: 12,
//     },
//     {
//       header: "Rise from Open %",
//       key: "riseFromOpen",
//       width: 16,
//     },
//     {
//       header: "Volume",
//       key: "volume",
//       width: 14,
//     },
//   ];

//   // =====================================================
//   // EXPORT DATA
//   // =====================================================

//   const buildExportRows = () =>
//     sorted.map((stock) => ({
//       symbol: stock.symbol,

//       ltp: stock.ltp ?? "",

//       dayPriceChange: stock.dayPriceChange ?? "",

//       pctChange: stock.pctChange ?? "",

//       open: stock.open ?? "",

//       low: stock.low ?? "",

//       high: stock.high ?? "",

//       riseFromOpen: stock.riseFromOpen ?? "",

//       volume: stock.volume ?? "",
//     }));

//   // =====================================================
//   // CSV
//   // =====================================================

//   const handleDownloadCSV = () =>
//     exportCSV({
//       rows: buildExportRows(),

//       columns: EXPORT_COLUMNS,

//       filename: activeScreener,

//       sheetName: title,
//     });

//   // =====================================================
//   // EXCEL
//   // =====================================================

//   const handleDownloadExcel = () =>
//     exportExcel({
//       rows: buildExportRows(),

//       columns: EXPORT_COLUMNS,

//       filename: activeScreener,

//       sheetName: title,
//     });

//   // =====================================================
//   // JSX
//   // =====================================================

//   return (
//     <div className="ohl">
//       {/* =================================================
//           HEADER
//       ================================================= */}

//       <div className="ohl__header">
//         <div className="ohl__header-left">
//           <div className="ohl__title-row">
//             <button className="ohl__back" onClick={() => navigate(-1)}>
//               ←
//             </button>

//             <h1 className="ohl__title">{title}</h1>
//           </div>

//           <p className="ohl__sub">{subtitle}</p>

//           <div className="ohl__condition-pill">
//             <span>Market Screener</span>

//             <span className="ohl__condition-eq">=</span>

//             <span className="ohl__condition-val ohl__condition-val--bull">
//               {title}
//             </span>
//           </div>
//         </div>

//         <div className="ohl__header-right">
//           {/* Refresh */}

//           <button
//             className="ohl__refresh-btn"
//             onClick={handleRefresh}
//             disabled={screenerLoading}
//             title={`Refresh ${title}`}
//           >
//             <FiRefreshCw size={14} />
//           </button>

//           {/* CSV */}

//           <button
//             className="ohl__refresh-btn"
//             onClick={handleDownloadCSV}
//             disabled={exporting || sorted.length === 0}
//           >
//             {exporting ? "…" : "CSV ⬇"}
//           </button>

//           {/* Excel */}

//           <button
//             className="ohl__refresh-btn"
//             onClick={handleDownloadExcel}
//             disabled={exporting || sorted.length === 0}
//           >
//             {exporting ? "…" : "Excel ⬇"}
//           </button>
//         </div>
//       </div>

//       {/* =================================================
//           SCREENER TABS
//       ================================================= */}

//       <div className="ohl__screener-tabs">
//         {SCREENER_TABS.map((tab) => (
//           <button
//             key={tab.key}
//             type="button"
//             className={`ohl__screener-tab ${
//               activeScreener === tab.key ? "ohl__screener-tab--active" : ""
//             }`}
//             onClick={() => handleTabChange(tab.key)}
//           >
//             {tab.label}
//           </button>
//         ))}
//       </div>

//       {/* =================================================
//           RESULT BAR
//       ================================================= */}

//       <div className="ohl__result-bar">
//         <span className="ohl__result-count">
//           Showing <b>{sorted.length}</b> of{" "}
//           <b>{Array.isArray(currentRows) ? currentRows.length : 0}</b> stocks
//         </span>

//         <span className="ohl__live-indicator">
//           <span className="ohl__live-dot" />

//           {title}
//         </span>
//       </div>

//       {/* =================================================
//           TABLE / LOADING / EMPTY
//       ================================================= */}

//       {screenerLoading && allStocks.length === 0 ? (
//         <div className="ohl__loading">Loading {title}...</div>
//       ) : sorted.length === 0 ? (
//         <div className="ohl__empty">
//           <div className="ohl__empty-icon">📈</div>

//           <div className="ohl__empty-title">No stocks found</div>

//           <div className="ohl__empty-sub">No results available for {title}</div>
//         </div>
//       ) : (
//         <div className="ohl__table-wrap">
//           <table className="ohl__table">
//             {/* ===========================================
//                 TABLE HEADER
//             =========================================== */}

//             <thead>
//               <tr>
//                 <SortTh label="Name" field="symbol" align="left" />

//                 <SortTh label="Price" field="ltp" />

//                 <SortTh label="Day Price Change" field="dayPriceChange" />

//                 <SortTh label="Change %" field="pctChange" />

//                 <SortTh label="Open" field="open" />

//                 <SortTh label="Low" field="low" />

//                 <SortTh label="High" field="high" />

//                 <SortTh label="Rise from Open" field="riseFromOpen" />

//                 <SortTh label="Volume" field="volume" />
//               </tr>
//             </thead>

//             {/* ===========================================
//                 TABLE BODY
//             =========================================== */}

//             <tbody>
//               {sorted.map((stock) => (
//                 <tr
//                   key={stock.symbol}
//                   className="ohl__row"
//                   onClick={() => navigate(`/globaltest/${stock.symbol}`)}
//                 >
//                   {/* Symbol */}

//                   <td className="ohl__td-name">
//                     <span className="ohl__symbol">{stock.symbol}</span>

//                     {stock.name && (
//                       <span className="ohl__stock-name">{stock.name}</span>
//                     )}
//                   </td>

//                   {/* Price */}

//                   <td className="ohl__td-num">
//                     {stock.ltp?.toLocaleString("en-US", {
//                       minimumFractionDigits: 2,

//                       maximumFractionDigits: 2,
//                     })}
//                   </td>

//                   {/* Day Price Change */}

//                   <td
//                     className={`ohl__td-num ${
//                       stock.dayPriceChange > 0
//                         ? "ohl__green"
//                         : stock.dayPriceChange < 0
//                           ? "ohl__red"
//                           : ""
//                     }`}
//                   >
//                     {stock.dayPriceChange > 0 ? "+" : ""}

//                     {stock.dayPriceChange?.toFixed(2)}
//                   </td>

//                   {/* Change % */}

//                   <td
//                     className={`ohl__td-num ${
//                       stock.pctChange > 0
//                         ? "ohl__green"
//                         : stock.pctChange < 0
//                           ? "ohl__red"
//                           : ""
//                     }`}
//                   >
//                     {stock.pctChange > 0 ? "+" : ""}
//                     {stock.pctChange?.toFixed(2)}%
//                   </td>

//                   {/* Open */}

//                   <td className="ohl__td-num">{stock.open?.toFixed(2)}</td>

//                   {/* Low */}

//                   <td className="ohl__td-num">{stock.low?.toFixed(2)}</td>

//                   {/* High */}

//                   <td className="ohl__td-num">{stock.high?.toFixed(2)}</td>

//                   {/* Rise From Open */}

//                   <td
//                     className={`ohl__td-num ${
//                       stock.riseFromOpen > 0
//                         ? "ohl__green"
//                         : stock.riseFromOpen < 0
//                           ? "ohl__red"
//                           : ""
//                     }`}
//                   >
//                     {stock.riseFromOpen > 0 ? "+" : ""}
//                     {stock.riseFromOpen?.toFixed(2)}%
//                   </td>

//                   {/* Volume */}

//                   <td className="ohl__td-num">
//                     {stock.volume ? stock.volume.toLocaleString("en-US") : "-"}
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>
//       )}

//       {/* =================================================
//           FOOTER
//       ================================================= */}

//       {sorted.length > 0 && (
//         <div className="ohl__footer">
//           <span>
//             Showing {sorted.length} of{" "}
//             {Array.isArray(currentRows) ? currentRows.length : 0} results
//           </span>
//         </div>
//       )}
//     </div>
//   );
// };

const SCREENER_TABS = [
  {
    key: "day_gainers",
    label: "Top Gainers",
    title: "Top Gainers",
    subtitle: "Stocks with the highest gains in today's market",
  },
  {
    key: "day_losers",
    label: "Top Losers",
    title: "Top Losers",
    subtitle: "Stocks with the highest losses in today's market",
  },
  {
    key: "most_actives",
    label: "Most Active",
    title: "Most Active Stocks",
    subtitle: "Stocks with the highest intraday trading activity",
  },
  {
    key: "undervalued_growth_stocks",
    label: "Growth",
    title: "Undervalued Growth Stocks",
    subtitle: "Undervalued stocks showing earnings growth",
  },
  {
    key: "growth_technology_stocks",
    label: "Technology",
    title: "Growth Technology Stocks",
    subtitle: "Technology stocks showing revenue growth",
  },
  {
    key: "undervalued_large_caps",
    label: "Large Caps",
    title: "Undervalued Large Caps",
    subtitle: "Large-cap stocks trading at attractive valuations",
  },
  {
    key: "aggressive_small_caps",
    label: "Small Caps",
    title: "Aggressive Small Caps",
    subtitle: "Small-cap stocks showing earnings growth",
  },
  {
    key: "small_cap_gainers",
    label: "Small Cap Gainers",
    title: "Small Cap Gainers",
    subtitle: "Small-cap stocks with strong one-day price gains",
  },
  {
    key: "crossover",
    label: "Crossover",
    title: "Crossover",
    subtitle: "Small-cap stocks with strong one-day price gains",
  },

  // {
  //   key: "NASDAQ100",
  //   label: "NASDAQ 100 Crossover",
  //   title: "NASDAQ 100 Crossover",
  //   subtitle: "MACD crossovers with SL, target and status (daily timeframe)",
  //   kind: "crossover",
  // },
  // {
  //   key: "SP500",
  //   label: "S&P 500 Crossover",
  //   title: "S&P 500 Crossover",
  //   subtitle: "MACD crossovers with SL, target and status (daily timeframe)",
  //   kind: "crossover",
  // },
];

const getStatusDisplay = (s) => {
  switch (s) {
    case "TARGET_HIT":
      return { label: "🎯 Target", cls: "ohl__status--target" };
    case "SL_HIT":
      return { label: "⚠️ SL", cls: "ohl__status--sl" };
    case "SL_THEN_TARGET":
      return { label: "🟡 SL → Target", cls: "ohl__status--mix" };
    case "OPEN":
      return { label: "⏳ Open", cls: "ohl__status--open" };
    case "PENDING":
      return { label: "⏸ Not Entered", cls: "ohl__status--pending" };
    default:
      return { label: s || "—", cls: "ohl__status--open" };
  }
};

const getBadgeClass = (pred) => {
  const p = pred?.toUpperCase();
  if (p === "BULLISH") return "ohl__badge--bull";
  if (p === "BEARISH") return "ohl__badge--bear";
  return "ohl__badge--neutral";
};

// const MarketScreener = () => {
//   const navigate = useNavigate();

//   const [activeScreener, setActiveScreener] = useState("day_gainers");

//   const [sortKey, setSortKey] = useState("pctChange");
//   const [sortDir, setSortDir] = useState("desc");

//   const { exportCSV, exportExcel, exporting } = useExport();

//   const { screener, getScreenerData, screenerLoading,globalCrossover,
//     globalCrossoverLoading,
//     globalCrossoverError,
//     loadGlobalCrossover,} = useMarketIndicators();

//   // =====================================================
//   // LOAD DATA ONCE
//   // =====================================================

//   useEffect(() => {
//     getScreenerData();
//   }, []);

//   // =====================================================
//   // ACTIVE TAB CONFIG
//   // =====================================================

//   const activeConfig =
//     SCREENER_TABS.find((tab) => tab.key === activeScreener) || SCREENER_TABS[0];
//   const isCrossover = activeConfig.kind === "crossover";

//      useEffect(() => {
//     if (isCrossover) {
//       loadGlobalCrossover(activeConfig.key); // uses context cache, hits net at most 1x/day
//     }
//   }, [activeScreener, isCrossover]);

//   const title = activeConfig.title;
//   const subtitle = activeConfig.subtitle;

//   // =====================================================
//   // IMPORTANT:
//   //
//   // screener =
//   // {
//   //   success: true,
//   //   data: {
//   //      day_gainers: [],
//   //      ...
//   //   }
//   // }
//   // =====================================================

//   const screenerData = screener?.data || {};

//   const currentRows = screenerData?.[activeScreener] || [];

//   console.log("Active Screener:", activeScreener);

//   console.log("Whole Screener:", screener);

//   console.log("Screener Data:", screenerData);

//   console.log("Current Rows:", currentRows);

//   // =====================================================
//   // NORMALIZE CURRENT TAB
//   // =====================================================

//   // const allStocks = useMemo(() => {
//   //   const rows = screener?.data?.[activeScreener] || [];

//   //   if (!Array.isArray(rows)) {
//   //     return [];
//   //   }

//   //   return rows
//   //     .map((item) => {
//   //       const open = Number(item?.regularMarketOpen || 0);

//   //       const ltp = Number(item?.regularMarketPrice || 0);

//   //       const riseFromOpen =
//   //         open && ltp ? Number((((ltp - open) / open) * 100).toFixed(2)) : 0;

//   //       return {
//   //         symbol: item?.symbol,

//   //         ltp: Number(item?.regularMarketPrice || 0),

//   //         dayPriceChange: Number(item?.regularMarketChange || 0),

//   //         pctChange: Number(item?.regularMarketChangePercent || 0),

//   //         open,

//   //         low: Number(item?.regularMarketDayLow || 0),

//   //         high: Number(item?.regularMarketDayHigh || 0),

//   //         riseFromOpen,

//   //         volume: Number(item?.regularMarketVolume || 0),

//   //         name: item?.shortName || item?.longName || item?.displayName || "",

//   //         currency: item?.currency || "USD",

//   //         marketCap: Number(item?.marketCap || 0),

//   //         fiftyTwoWeekHigh: Number(item?.fiftyTwoWeekHigh || 0),

//   //         fiftyTwoWeekLow: Number(item?.fiftyTwoWeekLow || 0),
//   //       };
//   //     })
//   //     .filter((stock) => stock.symbol && stock.ltp > 0);
//   // }, [screener, activeScreener]);

//   const allScreenerStocks = useMemo(() => {
//     if (isCrossover) return [];
//     const rows = screener?.data?.[activeScreener] || [];
//     if (!Array.isArray(rows)) return [];
//     return rows.map((item) => {
//       const open = Number(item?.regularMarketOpen || 0);
//       const ltp = Number(item?.regularMarketPrice || 0);
//       const riseFromOpen =
//         open && ltp ? Number((((ltp - open) / open) * 100).toFixed(2)) : 0;
//       return {
//         symbol: item?.symbol,
//         ltp,
//         dayPriceChange: Number(item?.regularMarketChange || 0),
//         pctChange: Number(item?.regularMarketChangePercent || 0),
//         open,
//         low: Number(item?.regularMarketDayLow || 0),
//         high: Number(item?.regularMarketDayHigh || 0),
//         riseFromOpen,
//         volume: Number(item?.regularMarketVolume || 0),
//         name: item?.shortName || item?.longName || item?.displayName || "",
//       };
//     }).filter((s) => s.symbol && s.ltp > 0);
//   }, [screener, activeScreener, isCrossover]);

//  const allStocks = isCrossover ? allCrossoverStocks : allScreenerStocks;
//    const allCrossoverStocks = useMemo(() => {
//     if (!isCrossover) return [];
//     const rows = globalCrossover?.[activeConfig.key]?.data || [];
//     return rows
//       .map((row) => {
//         const p = row?.predictions?.daily;
//         if (!p) return null;
//         const ltp =
//           row?.quote?.data?.last_price ?? row?.quote?.last_price ?? null;
//         return {
//           symbol: row.symbol,
//           name: row.company || "",
//           ltp: Number(ltp) || null,
//           crossover: p.macd_crossover || "none",
//           crossover_date: p.crossover_date || null,
//           crossover_close: p.crossover_close ?? null,
//           sl: p.sl_price ?? null,
//           target: p.target_price ?? null,
//           status: p.trade_status || "OPEN",
//           entry_date: p.entry_date || null,
//           exit_date: p.exit_date || null,
//           exit_reason: p.exit_reason || null,
//           holding_days: p.holding_days ?? null,
//           prediction: p.prediction || "Neutral",
//           rsi: p.rsi != null ? +Number(p.rsi).toFixed(2) : null,
//           macd: p.macd != null ? +Number(p.macd).toFixed(2) : null,
//         };
//       })
//       .filter(Boolean);
//   }, [isCrossover, globalCrossover, activeConfig.key]);

//   // =====================================================
//   // SORT
//   // =====================================================

//   const sorted = useMemo(() => {
//     return [...allStocks].sort((a, b) => {
//       const aVal = a?.[sortKey] ?? 0;

//       const bVal = b?.[sortKey] ?? 0;

//       if (typeof aVal === "string") {
//         return sortDir === "asc"
//           ? aVal.localeCompare(bVal)
//           : bVal.localeCompare(aVal);
//       }

//       return sortDir === "asc" ? aVal - bVal : bVal - aVal;
//     });
//   }, [allStocks, sortKey, sortDir]);

//   const handleSort = (key) => {
//     if (sortKey === key) {
//       setSortDir((prev) => (prev === "desc" ? "asc" : "desc"));
//     } else {
//       setSortKey(key);
//       setSortDir("desc");
//     }
//   };

//   // =====================================================
//   // TABLE HEADER
//   // =====================================================

//   const SortTh = ({ label, field, align }) => (
//     <th
//       onClick={() => handleSort(field)}
//       className={align === "left" ? "ohl__th-left" : ""}
//     >
//       {label}

//       {sortKey === field && (
//         <span className="ohl__sort-arrow">
//           {sortDir === "asc" ? " ↑" : " ↓"}
//         </span>
//       )}
//     </th>
//   );

//   // =====================================================
//   // TAB CHANGE
//   // =====================================================

//   const handleTabChange = (key) => {
//     setActiveScreener(key);

//     setSortKey("pctChange");
//     setSortDir("desc");
//   };

//   // =====================================================
//   // REFRESH ONLY CURRENT SCREENER
//   // =====================================================

//   const handleRefresh = () => {
//     getScreenerData(activeScreener);
//   };

//   // =====================================================
//   // EXPORT
//   // =====================================================

//   const EXPORT_COLUMNS = [
//     {
//       header: "Symbol",
//       key: "symbol",
//       width: 15,
//     },
//     {
//       header: "Price",
//       key: "ltp",
//       width: 12,
//     },
//     {
//       header: "Day Price Change",
//       key: "dayPriceChange",
//       width: 16,
//     },
//     {
//       header: "Change %",
//       key: "pctChange",
//       width: 12,
//     },
//     {
//       header: "Open",
//       key: "open",
//       width: 12,
//     },
//     {
//       header: "Low",
//       key: "low",
//       width: 12,
//     },
//     {
//       header: "High",
//       key: "high",
//       width: 12,
//     },
//     {
//       header: "Rise from Open %",
//       key: "riseFromOpen",
//       width: 16,
//     },
//     {
//       header: "Volume",
//       key: "volume",
//       width: 14,
//     },
//   ];

//   const buildExportRows = () =>
//     sorted.map((stock) => ({
//       symbol: stock.symbol,

//       ltp: stock.ltp ?? "",

//       dayPriceChange: stock.dayPriceChange ?? "",

//       pctChange: stock.pctChange ?? "",

//       open: stock.open ?? "",

//       low: stock.low ?? "",

//       high: stock.high ?? "",

//       riseFromOpen: stock.riseFromOpen ?? "",

//       volume: stock.volume ?? "",
//     }));

//   const handleDownloadCSV = () =>
//     exportCSV({
//       rows: buildExportRows(),

//       columns: EXPORT_COLUMNS,

//       filename: activeScreener,

//       sheetName: title,
//     });

//   const handleDownloadExcel = () =>
//     exportExcel({
//       rows: buildExportRows(),

//       columns: EXPORT_COLUMNS,

//       filename: activeScreener,

//       sheetName: title,
//     });

//   // =====================================================
//   // JSX
//   // =====================================================

//   return (
//     <div className="ohl">
//       {/* ================= HEADER ================= */}

//       <div className="ohl__header">
//         <div className="ohl__header-left">
//           <div className="ohl__title-row">
//             <button className="ohl__back" onClick={() => navigate(-1)}>
//               ←
//             </button>

//             <h1 className="ohl__title">{title}</h1>
//           </div>

//           <p className="ohl__sub">{subtitle}</p>

//           <div className="ohl__condition-pill">
//             <span>Market Screener</span>

//             <span className="ohl__condition-eq">=</span>

//             <span className="ohl__condition-val ohl__condition-val--bull">
//               {title}
//             </span>
//           </div>
//         </div>

//         <div className="ohl__header-right">
//           <button
//             className="ohl__refresh-btn"
//             onClick={handleRefresh}
//             disabled={screenerLoading}
//           >
//             <FiRefreshCw size={14} />
//           </button>

//           <button
//             className="ohl__refresh-btn"
//             onClick={handleDownloadCSV}
//             disabled={exporting || sorted.length === 0}
//           >
//             {exporting ? "…" : "CSV ⬇"}
//           </button>

//           <button
//             className="ohl__refresh-btn"
//             onClick={handleDownloadExcel}
//             disabled={exporting || sorted.length === 0}
//           >
//             {exporting ? "…" : "Excel ⬇"}
//           </button>
//         </div>
//       </div>

//       {/* ================= TABS ================= */}

//       <div className="ohl__screener-tabs">
//         {SCREENER_TABS.map((tab) => (
//           <button
//             key={tab.key}
//             type="button"
//             className={`ohl__screener-tab ${
//               activeScreener === tab.key ? "ohl__screener-tab--active" : ""
//             }`}
//             onClick={() => handleTabChange(tab.key)}
//           >
//             {tab.label}
//           </button>
//         ))}
//       </div>

//       {/* ================= RESULT BAR ================= */}

//       <div className="ohl__result-bar">
//         <span className="ohl__result-count">
//           Showing <b>{sorted.length}</b> of{" "}
//           <b>{Array.isArray(currentRows) ? currentRows.length : 0}</b> stocks
//         </span>

//         <span className="ohl__live-indicator">
//           <span className="ohl__live-dot" />

//           {title}
//         </span>
//       </div>

//       {/* ================= TABLE ================= */}

//       {screenerLoading && allStocks.length === 0 ? (
//         <div className="ohl__loading">Loading {title}...</div>
//       ) : sorted.length === 0 ? (
//         <div className="ohl__empty">
//           <div className="ohl__empty-icon">📈</div>

//           <div className="ohl__empty-title">No stocks found</div>

//           <div className="ohl__empty-sub">No results available for {title}</div>
//         </div>
//       ) : (
//         <div className="ohl__table-wrap">
//           <table className="ohl__table">
//             <thead>
//               <tr>
//                 <SortTh label="Name" field="symbol" align="left" />

//                 <SortTh label="Price" field="ltp" />

//                 <SortTh label="Day Price Change" field="dayPriceChange" />

//                 <SortTh label="Change %" field="pctChange" />

//                 <SortTh label="Open" field="open" />

//                 <SortTh label="Low" field="low" />

//                 <SortTh label="High" field="high" />

//                 <SortTh label="Rise from Open" field="riseFromOpen" />

//                 <SortTh label="Volume" field="volume" />
//               </tr>
//             </thead>

//             <tbody>
//               {sorted.map((stock) => (
//                 <tr
//                   key={stock.symbol}
//                   className="ohl__row"
//                   onClick={() => navigate(`/globaltest/${stock.symbol}`)}
//                 >
//                   {/* NAME */}

//                   <td className="ohl__td-name">
//                     <span className="ohl__symbol">{stock.symbol}</span>

//                     {stock.name && (
//                       <span className="ohl__stock-name">{stock.name}</span>
//                     )}
//                   </td>

//                   {/* PRICE */}

//                   <td className="ohl__td-num">
//                     {stock.ltp?.toLocaleString("en-US", {
//                       minimumFractionDigits: 2,

//                       maximumFractionDigits: 2,
//                     })}
//                   </td>

//                   {/* DAY CHANGE */}

//                   <td
//                     className={`ohl__td-num ${
//                       stock.dayPriceChange > 0
//                         ? "ohl__green"
//                         : stock.dayPriceChange < 0
//                           ? "ohl__red"
//                           : ""
//                     }`}
//                   >
//                     {stock.dayPriceChange > 0 ? "+" : ""}

//                     {stock.dayPriceChange?.toFixed(2)}
//                   </td>

//                   {/* CHANGE % */}

//                   <td
//                     className={`ohl__td-num ${
//                       stock.pctChange > 0
//                         ? "ohl__green"
//                         : stock.pctChange < 0
//                           ? "ohl__red"
//                           : ""
//                     }`}
//                   >
//                     {stock.pctChange > 0 ? "+" : ""}
//                     {stock.pctChange?.toFixed(2)}%
//                   </td>

//                   {/* OPEN */}

//                   <td className="ohl__td-num">{stock.open?.toFixed(2)}</td>

//                   {/* LOW */}

//                   <td className="ohl__td-num">{stock.low?.toFixed(2)}</td>

//                   {/* HIGH */}

//                   <td className="ohl__td-num">{stock.high?.toFixed(2)}</td>

//                   {/* RISE */}

//                   <td
//                     className={`ohl__td-num ${
//                       stock.riseFromOpen > 0
//                         ? "ohl__green"
//                         : stock.riseFromOpen < 0
//                           ? "ohl__red"
//                           : ""
//                     }`}
//                   >
//                     {stock.riseFromOpen > 0 ? "+" : ""}
//                     {stock.riseFromOpen?.toFixed(2)}%
//                   </td>

//                   {/* VOLUME */}

//                   <td className="ohl__td-num">
//                     {stock.volume ? stock.volume.toLocaleString("en-US") : "-"}
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>
//       )}

//       {/* ================= FOOTER ================= */}

//       {sorted.length > 0 && (
//         <div className="ohl__footer">
//           <span>
//             Showing {sorted.length} of {currentRows.length} results
//           </span>
//         </div>
//       )}
//     </div>
//   );
// };

// Existing code working

const MarketScreener = () => {
  const navigate = useNavigate();
  const [activeScreener, setActiveScreener] = useState("day_gainers");
  const [sortKey, setSortKey] = useState("pctChange");
  const [sortDir, setSortDir] = useState("desc");

  const { exportCSV, exportExcel, exporting } = useExport();
  const {
    screener,
    getScreenerData,
    screenerLoading,

    // ✅ new
    globalCrossover,
    globalCrossoverLoading,
    globalCrossoverError,
    loadGlobalCrossover,
  } = useMarketIndicators();

  const activeConfig =
    SCREENER_TABS.find((t) => t.key === activeScreener) || SCREENER_TABS[0];
  const isCrossover = activeConfig.kind === "crossover";

  // ── initial screener load ──
  useEffect(() => {
    getScreenerData();
  }, []);

  // ── crossover load happens only when a crossover tab is selected ──
  useEffect(() => {
    if (isCrossover) {
      loadGlobalCrossover(activeConfig.key); // uses context cache, hits net at most 1x/day
    }
  }, [activeScreener, isCrossover]);

  // ── normalized screener rows (unchanged) ──
  const screenerData = screener?.data || {};
  const currentScreenerRows = isCrossover
    ? []
    : screenerData[activeScreener] || [];

  const allScreenerStocks = useMemo(() => {
    if (isCrossover) return [];
    const rows = screener?.data?.[activeScreener] || [];

    if (!Array.isArray(rows)) return [];
    return rows
      .map((item) => {
        const open = Number(item?.regularMarketOpen || 0);
        const ltp = Number(item?.regularMarketPrice || 0);
        const riseFromOpen =
          open && ltp ? Number((((ltp - open) / open) * 100).toFixed(2)) : 0;
        return {
          symbol: item?.symbol,
          ltp,
          dayPriceChange: Number(item?.regularMarketChange || 0),
          pctChange: Number(item?.regularMarketChangePercent || 0),
          open,
          low: Number(item?.regularMarketDayLow || 0),
          high: Number(item?.regularMarketDayHigh || 0),
          riseFromOpen,
          volume: Number(item?.regularMarketVolume || 0),
          name: item?.shortName || item?.longName || item?.displayName || "",
        };
      })
      .filter((s) => s.symbol && s.ltp > 0);
  }, [screener, activeScreener, isCrossover]);
  const { ticks, priceOf, flashOf, live } = useGlobalLiveFeed(
    allScreenerStocks.map((s) => s.symbol),
  );

  const liveScreenerStocks = useMemo(
    () =>
      allScreenerStocks.map((s) => {
        const t = priceOf(s.symbol);
        if (!t?.ltp) return { ...s, live: false }; // no tick → keep Yahoo values

        const ltp = Number(t.ltp);
        const prevClose = Number(t.prevClose) || s.ltp - s.dayPriceChange;
        const open = Number(t.open) || s.open;
        const high = Math.max(Number(t.high) || 0, s.high || 0, ltp);
        const low = Math.min(
          ...[Number(t.low), s.low, ltp].filter((v) => v > 0),
        );

        return {
          ...s,
          ltp,
          dayPriceChange: prevClose
            ? Number((ltp - prevClose).toFixed(2))
            : s.dayPriceChange,
          pctChange: prevClose
            ? Number((((ltp - prevClose) / prevClose) * 100).toFixed(2))
            : s.pctChange,
          open,
          high,
          low,
          riseFromOpen: open
            ? Number((((ltp - open) / open) * 100).toFixed(2))
            : s.riseFromOpen,
          volume: Number(t.volume) || s.volume,
          live: true,
        };
      }),
    [allScreenerStocks, ticks],
  );
  // ── normalized crossover rows (daily timeframe only in this tab) ──
  const allCrossoverStocks = useMemo(() => {
    if (!isCrossover) return [];
    const rows = globalCrossover?.[activeConfig.key]?.data || [];
    return rows
      .map((row) => {
        const p = row?.predictions?.daily;
        if (!p) return null;
        const ltp =
          row?.quote?.data?.last_price ?? row?.quote?.last_price ?? null;
        return {
          symbol: row.symbol,
          name: row.company || "",
          ltp: Number(ltp) || null,
          crossover: p.macd_crossover || "none",
          crossover_date: p.crossover_date || null,
          crossover_close: p.crossover_close ?? null,
          sl: p.sl_price ?? null,
          target: p.target_price ?? null,
          status: p.trade_status || "OPEN",
          entry_date: p.entry_date || null,
          exit_date: p.exit_date || null,
          exit_reason: p.exit_reason || null,
          holding_days: p.holding_days ?? null,
          prediction: p.prediction || "Neutral",
          rsi: p.rsi != null ? +Number(p.rsi).toFixed(2) : null,
          macd: p.macd != null ? +Number(p.macd).toFixed(2) : null,
        };
      })
      .filter(Boolean);
  }, [isCrossover, globalCrossover, activeConfig.key]);

  // ── sorted rows for whichever tab is active ──
  // const allStocks = isCrossover ? allCrossoverStocks : allScreenerStocks;
  const allStocks = isCrossover ? allCrossoverStocks : liveScreenerStocks;

  const sorted = useMemo(() => {
    return [...allStocks].sort((a, b) => {
      const av = a?.[sortKey] ?? 0;
      const bv = b?.[sortKey] ?? 0;
      if (
        sortKey === "crossover_date" ||
        sortKey === "entry_date" ||
        sortKey === "exit_date"
      ) {
        const at = av ? new Date(av).getTime() : 0;
        const bt = bv ? new Date(bv).getTime() : 0;
        return sortDir === "asc" ? at - bt : bt - at;
      }
      if (typeof av === "string") {
        return sortDir === "asc" ? av.localeCompare(bv) : bv.localeCompare(av);
      }
      return sortDir === "asc" ? av - bv : bv - av;
    });
  }, [allStocks, sortKey, sortDir]);

  const handleSort = (key) => {
    if (sortKey === key) setSortDir((p) => (p === "desc" ? "asc" : "desc"));
    else {
      setSortKey(key);
      setSortDir("desc");
    }
  };

  const SortTh = ({ label, field, align }) => (
    <th
      onClick={() => handleSort(field)}
      className={align === "left" ? "ohl__th-left" : ""}
    >
      {label}
      {sortKey === field && (
        <span className="ohl__sort-arrow">
          {sortDir === "asc" ? " ↑" : " ↓"}
        </span>
      )}
    </th>
  );

  // const handleTabChange = (key) => {
  //   setActiveScreener(key);
  //   const isXO = SCREENER_TABS.find((t) => t.key === key)?.kind === "crossover";
  //   setSortKey(isXO ? "crossover_date" : "pctChange");
  //   setSortDir("desc");
  // };
  const handleTabChange = (key) => {
    if (key === "crossover") {
      navigate("/global-screener?tab=nasdaq100");
      return;
    }
    // if (key === "SP500") {
    //   navigate("/global-screener?tab=sp500");
    //   return;
    // }
    setActiveScreener(key);
    setSortKey("pctChange");
    setSortDir("desc");
  };

  const handleRefresh = () => {
    if (isCrossover) loadGlobalCrossover(activeConfig.key, { force: true });
    else getScreenerData(activeScreener);
  };

  // ── export columns switch per tab kind ──
  const SCREENER_COLUMNS = [
    { header: "Symbol", key: "symbol", width: 15 },
    { header: "Price", key: "ltp", width: 12 },
    { header: "Day Price Change", key: "dayPriceChange", width: 16 },
    { header: "Change %", key: "pctChange", width: 12 },
    { header: "Open", key: "open", width: 12 },
    { header: "Low", key: "low", width: 12 },
    { header: "High", key: "high", width: 12 },
    { header: "Rise from Open %", key: "riseFromOpen", width: 16 },
    { header: "Volume", key: "volume", width: 14 },
  ];
  const CROSSOVER_COLUMNS = [
    { header: "Symbol", key: "symbol", width: 12 },
    { header: "Company", key: "name", width: 22 },
    { header: "LTP", key: "ltp", width: 10 },
    { header: "Crossover", key: "crossover", width: 12 },
    { header: "Crossover Date", key: "crossover_date", width: 14 },
    { header: "Crossover Close", key: "crossover_close", width: 14 },
    { header: "SL", key: "sl", width: 10 },
    { header: "Target", key: "target", width: 10 },
    { header: "Status", key: "status", width: 14 },
    { header: "Entry Date", key: "entry_date", width: 12 },
    { header: "Exit Date", key: "exit_date", width: 12 },
    { header: "Momentum", key: "prediction", width: 12 },
    { header: "RSI", key: "rsi", width: 8 },
    { header: "MACD", key: "macd", width: 10 },
  ];

  const buildExportRows = () =>
    sorted.map((s) => {
      const obj = {};
      (isCrossover ? CROSSOVER_COLUMNS : SCREENER_COLUMNS).forEach((c) => {
        obj[c.key] = s[c.key] ?? "";
      });
      return obj;
    });

  const doExport = (fn) =>
    fn({
      rows: buildExportRows(),
      columns: isCrossover ? CROSSOVER_COLUMNS : SCREENER_COLUMNS,
      filename: activeConfig.key,
      sheetName: activeConfig.title,
    });

  const loading = isCrossover ? globalCrossoverLoading : screenerLoading;
  const errorMsg = isCrossover ? globalCrossoverError : null;

  const cachedDate = isCrossover && globalCrossover?.[activeConfig.key]?.date;

  return (
    <div className="ohl">
      {/* Header */}
      <div className="ohl__header">
        <div className="ohl__header-left">
          <div className="ohl__title-row">
            <button className="ohl__back" onClick={() => navigate(-1)}>
              ←
            </button>
            <h1 className="ohl__title">{activeConfig.title}</h1>
          </div>
          <p className="ohl__sub">{activeConfig.subtitle}</p>
          <div className="ohl__condition-pill">
            <span>
              {isCrossover ? "Crossover Universe" : "Market Screener"}
            </span>
            <span className="ohl__condition-eq">=</span>
            <span className="ohl__condition-val ohl__condition-val--bull">
              {activeConfig.title}
            </span>
            {cachedDate && (
              <span style={{ marginLeft: 8, fontSize: 11, color: "#6b7280" }}>
                as of {cachedDate}
              </span>
            )}
          </div>
        </div>

        <div className="ohl__header-right">
          <button
            className="ohl__refresh-btn"
            onClick={handleRefresh}
            disabled={loading}
          >
            <FiRefreshCw size={14} />
          </button>
          <button
            className="ohl__refresh-btn"
            onClick={() => doExport(exportCSV)}
            disabled={exporting || !sorted.length}
          >
            {exporting ? "…" : "CSV ⬇"}
          </button>
          <button
            className="ohl__refresh-btn"
            onClick={() => doExport(exportExcel)}
            disabled={exporting || !sorted.length}
          >
            {exporting ? "…" : "Excel ⬇"}
          </button>
        </div>
      </div>

      {/* Tabs */}
      <div className="ohl__screener-tabs">
        {SCREENER_TABS.map((tab) => (
          <button
            key={tab.key}
            type="button"
            className={`ohl__screener-tab ${
              activeScreener === tab.key ? "ohl__screener-tab--active" : ""
            }`}
            onClick={() => handleTabChange(tab.key)}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {/* Result bar */}
      <div className="ohl__result-bar">
        <span className="ohl__result-count">
          Showing <b>{sorted.length}</b> stocks
        </span>
        <span className="ohl__live-indicator">
          <span className="ohl__live-dot" />
          {activeConfig.title}
        </span>
      </div>

      {/* Body */}
      {loading && !allStocks.length ? (
        <div className="ohl__loading">Loading {activeConfig.title}...</div>
      ) : errorMsg ? (
        <div className="ohl__empty">
          <div className="ohl__empty-title">{errorMsg}</div>
        </div>
      ) : !sorted.length ? (
        <div className="ohl__empty">
          <div className="ohl__empty-icon">📈</div>
          <div className="ohl__empty-title">No stocks found</div>
          <div className="ohl__empty-sub">
            No results available for {activeConfig.title}
          </div>
        </div>
      ) : isCrossover ? (
        // ═══ CROSSOVER TABLE ═══
        <div className="ohl__table-wrap">
          <table className="ohl__table">
            <thead>
              <tr>
                <SortTh label="Symbol" field="symbol" align="left" />
                <SortTh label="LTP" field="ltp" />
                <SortTh label="Crossover" field="crossover" />
                <SortTh label="Crossover Date" field="crossover_date" />
                <SortTh label="Crossover Close" field="crossover_close" />
                <SortTh label="SL" field="sl" />
                <SortTh label="Target" field="target" />
                <SortTh label="Entry Date" field="entry_date" />
                <SortTh label="Exit Date" field="exit_date" />
                <th>Status</th>
                <SortTh label="Momentum" field="prediction" />
                <SortTh label="RSI" field="rsi" />
                <SortTh label="MACD" field="macd" />
              </tr>
            </thead>
            <tbody>
              {sorted.map((s) => {
                const status = getStatusDisplay(s.status);
                return (
                  <tr
                    key={s.symbol}
                    className="ohl__row"
                    onClick={() => navigate(`/globaltest/${s.symbol}`)}
                  >
                    <td className="ohl__td-name">
                      <span className="ohl__symbol">{s.symbol}</span>
                      {s.name && (
                        <span className="ohl__stock-name">{s.name}</span>
                      )}
                    </td>
                    <td className="ohl__td-num">{s.ltp ? `$${s.ltp}` : "—"}</td>
                    <td className="ohl__td-num">
                      <span
                        className={
                          s.crossover === "bullish"
                            ? "ohl__green"
                            : s.crossover === "bearish"
                              ? "ohl__red"
                              : ""
                        }
                      >
                        {s.crossover === "bullish"
                          ? "↑ Bullish"
                          : s.crossover === "bearish"
                            ? "↓ Bearish"
                            : "—"}
                      </span>
                    </td>
                    <td className="ohl__td-num">{s.crossover_date || "—"}</td>
                    <td className="ohl__td-num">{s.crossover_close ?? "—"}</td>
                    <td className="ohl__td-num ohl__red">
                      {s.sl ? `$${s.sl}` : "—"}
                    </td>
                    <td className="ohl__td-num ohl__green">
                      {s.target ? `$${s.target}` : "—"}
                    </td>
                    <td className="ohl__td-num">{s.entry_date || "—"}</td>
                    <td className="ohl__td-num">
                      {s.exit_date ? (
                        <>
                          {s.exit_date}
                          {s.exit_reason && (
                            <small
                              style={{
                                display: "block",
                                color:
                                  s.exit_reason === "SL"
                                    ? "#f87171"
                                    : "#249966",
                                fontSize: 11,
                                fontWeight: 600,
                              }}
                            >
                              {s.exit_reason}
                              {s.holding_days != null &&
                                ` · ${s.holding_days}d`}
                            </small>
                          )}
                        </>
                      ) : (
                        "—"
                      )}
                    </td>
                    <td className="ohl__td-num">
                      <span className={`ohl__status ${status.cls}`}>
                        {status.label}
                      </span>
                    </td>
                    <td className="ohl__td-num">
                      <span
                        className={`ohl__badge ${getBadgeClass(s.prediction)}`}
                      >
                        {s.prediction || "—"}
                      </span>
                    </td>
                    <td
                      className={`ohl__td-num ${
                        s.rsi > 55 ? "ohl__green" : s.rsi < 45 ? "ohl__red" : ""
                      }`}
                    >
                      {s.rsi ?? "—"}
                    </td>
                    <td
                      className={`ohl__td-num ${
                        s.macd > 0 ? "ohl__green" : s.macd < 0 ? "ohl__red" : ""
                      }`}
                    >
                      {s.macd ?? "—"}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      ) : (
        // ═══ SCREENER TABLE (unchanged) ═══
        <div className="ohl__table-wrap">
          <table className="ohl__table">
            <thead>
              <tr>
                <SortTh label="Name" field="symbol" align="left" />
                <SortTh label="Price" field="ltp" />
                <SortTh label="Day Price Change" field="dayPriceChange" />
                <SortTh label="Change %" field="pctChange" />
                <SortTh label="Open" field="open" />
                <SortTh label="Low" field="low" />
                <SortTh label="High" field="high" />
                <SortTh label="Rise from Open" field="riseFromOpen" />
                <SortTh label="Volume" field="volume" />
              </tr>
            </thead>
            <tbody>
              {sorted.map((stock) => (
                <tr
                  key={stock.symbol}
                  className="ohl__row"
                  onClick={() => navigate(`/globaltest/${stock.symbol}`)}
                >
                  <td className="ohl__td-name">
                    <span className="ohl__symbol">{stock.symbol}</span>
                    {stock.name && (
                      <span className="ohl__stock-name">{stock.name}</span>
                    )}
                  </td>
                  <td className="ohl__td-num">
                    {stock.ltp?.toLocaleString("en-US", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                  </td>
                  <td
                    className={`ohl__td-num ${
                      stock.dayPriceChange > 0
                        ? "ohl__green"
                        : stock.dayPriceChange < 0
                          ? "ohl__red"
                          : ""
                    }`}
                  >
                    {stock.dayPriceChange > 0 ? "+" : ""}
                    {stock.dayPriceChange?.toFixed(2)}
                  </td>
                  <td
                    className={`ohl__td-num ${
                      stock.pctChange > 0
                        ? "ohl__green"
                        : stock.pctChange < 0
                          ? "ohl__red"
                          : ""
                    }`}
                  >
                    {stock.pctChange > 0 ? "+" : ""}
                    {stock.pctChange?.toFixed(2)}%
                  </td>
                  <td className="ohl__td-num">{stock.open?.toFixed(2)}</td>
                  <td className="ohl__td-num">{stock.low?.toFixed(2)}</td>
                  <td className="ohl__td-num">{stock.high?.toFixed(2)}</td>
                  <td
                    className={`ohl__td-num ${
                      stock.riseFromOpen > 0
                        ? "ohl__green"
                        : stock.riseFromOpen < 0
                          ? "ohl__red"
                          : ""
                    }`}
                  >
                    {stock.riseFromOpen > 0 ? "+" : ""}
                    {stock.riseFromOpen?.toFixed(2)}%
                  </td>
                  <td className="ohl__td-num">
                    {stock.volume ? stock.volume.toLocaleString("en-US") : "-"}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {sorted.length > 0 && (
        <div className="ohl__footer">
          <span>
            Showing {sorted.length}
            {!isCrossover && ` of ${currentScreenerRows.length}`} results
          </span>
        </div>
      )}
    </div>
  );
};

export default MarketScreener;
